import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { toast } from "react-toastify";
import { showApiErrorToast } from "../utils/helpers";

const updateVisitAdvancedSurveys = async ({
  visitId,
  stepId,
  surveys,
  disallowInvSurveySelection,
  isAllSurvey,
}) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (stepId) params.append("step_id", stepId);

  const URL = `${__API_URL__}/api/survey/visits/${visitId}/advanced-surveys/?${params.toString()}`;

  const payload = { surveys };
  if (disallowInvSurveySelection !== undefined) {
    payload.disallow_inv_survey_selection = disallowInvSurveySelection;
  }
  if (isAllSurvey !== undefined) payload.is_all_survey = isAllSurvey;

  const res = await axios.put(URL, payload, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useUpdateVisitAdvancedSurveysMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateVisitAdvancedSurveys,
    onSuccess: (_, variables) => {
      toast.success("Advanced surveys updated");
      queryClient.invalidateQueries({
        queryKey: ["visit_advanced_surveys", variables.visitId],
      });
      queryClient.invalidateQueries({ queryKey: ["trial_distinct_forms"] });
    },
    onError: (error) => {
      showApiErrorToast(error, "Failed to update advanced surveys");
    },
  });
};

export default useUpdateVisitAdvancedSurveysMutation;
